import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { Atomic } from "@universityofmaryland/web-elements-library";
import * as Styles from "@universityofmaryland/web-styles-library";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { FeedStateEvent } from "./_types.js";
function createEmptyElement(config = {}) {
  const {
    message = "No results found",
    linkUrl,
    linkText,
    isThemeDark = false,
    isAlignedCenter = true
  } = config;
  const headline = new ElementBuilder(document.createElement("p")).styled(Styles.typography.sans.compose("extralarge")).withStyles({
    element: {
      textTransform: "uppercase",
      color: theme.foreground(isThemeDark)
    }
  }).build();
  headline.element.textContent = message;
  const composite = new ElementBuilder().styled(Styles.layout.grid.stacked).withChild(headline).withStyles({
    element: {
      [`& *`]: {
        textAlign: isAlignedCenter ? "center" : "left"
      },
      [`& *:not(:first-child)`]: {
        marginTop: `${Styles.token.spacing.md}`
      }
    }
  });
  if (linkUrl && linkText) {
    const link = document.createElement("a");
    link.textContent = linkText;
    link.setAttribute("href", linkUrl);
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    const ctaButton = Atomic.actions.options({
      element: link,
      isTypeOutline: true,
      isThemeDark
    });
    composite.withChild(ctaButton);
  }
  return composite.build();
}
class EmptyState {
  constructor(config = {}) {
    this.container = null;
    this.config = config;
    this.model = createEmptyElement(config);
  }
  /**
   * Render the empty state in a container
   */
  render(container) {
    this.container = container;
    container.appendChild(this.model.element);
    container.dispatchEvent(
      new CustomEvent(FeedStateEvent.EMPTY_SHOWN, {
        bubbles: true,
        detail: {
          message: this.config.message,
          timestamp: Date.now()
        }
      })
    );
  }
  /**
   * Update the empty state message
   */
  updateMessage(message) {
    const headline = this.model.element.querySelector("p");
    if (headline) {
      headline.textContent = message;
      this.config.message = message;
    }
  }
  /**
   * Remove the empty state from DOM
   */
  destroy() {
    if (this.model.element.parentNode) {
      this.model.element.remove();
    }
    this.container = null;
  }
  /**
   * Get the empty state element
   */
  get element() {
    return this.model.element;
  }
  /**
   * Get the empty state styles
   */
  get styles() {
    return this.model.styles;
  }
}
export {
  EmptyState,
  createEmptyElement
};
//# sourceMappingURL=empty.js.map
